import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
export function CaseStudies() {
  const cases = [{
    title: 'Infrastructure Procurement Programme',
    client: 'West African Government Infrastructure Project',
    region: 'Africa',
    challenge: 'Large-scale infrastructure development programme requiring construction materials, equipment, and logistics coordination across multiple international suppliers.',
    solution: 'Coordinated supplier sourcing, specification evaluation, and contract negotiation for construction materials and equipment from manufacturers across Europe and Asia.',
    outcome: '40+ suppliers coordinated',
    metrics: ['Multi-sector sourcing', '18-month programme', 'On-time delivery']
  }, {
    title: 'ICT Infrastructure Tender Support',
    client: 'Southeast Asian Public Sector Programme',
    region: 'Asia-Pacific',
    challenge: 'National digital transformation initiative requiring network infrastructure, data centre equipment, and software licensing across multiple regions.',
    solution: 'Facilitated supplier verification, technical specification review, and competitive pricing evaluation across global ICT manufacturers and integrators.',
    outcome: '12+ suppliers evaluated',
    metrics: ['Cross-border sourcing', 'Compliance achieved', 'Phased rollout']
  }, {
    title: 'Energy Equipment Sourcing',
    client: 'Gulf Region Energy Project',
    region: 'Middle East',
    challenge: 'Major energy infrastructure project requiring power generation equipment, transformers, and electrical distribution systems with strict technical specifications.',
    solution: 'Sourced and verified specialist manufacturers across Europe and Asia, managed technical evaluation, and coordinated logistics for high-value equipment delivery.',
    outcome: 'Multi-million GBP project',
    metrics: ['Technical compliance', 'Specialist suppliers', '24-month timeline']
  }];
  return <section id="capability-highlights" className="py-24 px-6 bg-navy-light" data-id="element-24">
      <div className="max-w-7xl mx-auto" data-id="element-25">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-26">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-27">
            <div className="w-12 h-px bg-gold" data-id="element-28"></div>
            <span className="text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-29">
              Capability Highlights
            </span>
            <div className="w-12 h-px bg-gold" data-id="element-30"></div>
          </div>
          <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-4" data-id="element-31">
            Proven Track Record
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-32">
            Representative examples of our procurement coordination and sourcing
            capabilities across global markets
          </p>
        </motion.div>

        {/* Case Studies */}
        <div className="space-y-8" data-id="element-33">
          {cases.map((study, i) => <motion.div key={study.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-navy-dark border border-slate-800 hover:border-gold/50 p-8 rounded-lg transition-all group" data-id="element-34">
              <div className="flex flex-col lg:flex-row gap-8" data-id="element-35">
                {/* Left Content */}
                <div className="flex-1" data-id="element-36">
                  <div className="flex items-center gap-3 mb-2" data-id="element-37">
                    <div className="text-gold text-sm font-semibold" data-id="element-38">
                      {study.client}
                    </div>
                    <span className="text-xs bg-navy-light border border-slate-800 text-slate-400 px-2 py-0.5 rounded-full" data-id="element-39">
                      {study.region}
                    </span>
                  </div>
                  <h3 className="text-2xl font-semibold text-white mb-4" data-id="element-40">
                    {study.title}
                  </h3>

                  <div className="space-y-4 mb-6" data-id="element-41">
                    <div data-id="element-42">
                      <div className="text-slate-400 text-sm font-semibold mb-1" data-id="element-43">
                        Challenge
                      </div>
                      <p className="text-slate-300" data-id="element-44">{study.challenge}</p>
                    </div>
                    <div data-id="element-45">
                      <div className="text-slate-400 text-sm font-semibold mb-1" data-id="element-46">
                        Solution
                      </div>
                      <p className="text-slate-300" data-id="element-47">{study.solution}</p>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-3" data-id="element-48">
                    {study.metrics.map(metric => <span key={metric} className="text-xs bg-navy-light border border-slate-800 text-slate-300 px-3 py-1.5 rounded-full" data-id="element-49">
                        {metric}
                      </span>)}
                  </div>
                </div>

                {/* Right Outcome */}
                <div className="lg:w-64 flex-shrink-0" data-id="element-50">
                  <div className="bg-navy-light border-l-4 border-gold p-6 rounded-lg h-full flex flex-col justify-center" data-id="element-51">
                    <div className="flex items-center gap-2 mb-2" data-id="element-52">
                      <TrendingUpIcon size={20} className="text-gold" data-id="element-53" />
                      <span className="text-slate-400 text-sm font-semibold" data-id="element-54">
                        Outcome
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-55">
                      {study.outcome}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}